export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/layouts/Login")
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/layouts/pages/NotFound")
  },
  {
    path: "/printReport/ageChildrenReport",
    name: "ageChildrenReport",
    component: () => import("@/views/printReport/ageChildrenReport"),
  },
  {
    path: "/printReport/bmdReport",
    name: "bmdReport",
    component: () => import("../views/printReport/bmdReport"),
  },
  {
    path: "/printReport/dentalCariesReport",
    name: "dentalCariesReport",
    component: () => import("../views/printReport/dentalCariesReport"),
  },
  {
    path: "/printReport/drReport",
    name: "drReport",
    component: () => import("@/views/printReport/drReport"),
  },
  {
    path: "/printReport/generalInspectionReport",
    name: "generalInspectionReport",
    component: () => import("@/views/printReport/generalInspectionReport"),
  },
  {
    path: "/printReport/hearingReport",
    name: "hearingReport",
    component: () => import("@/views/printReport/hearingReport"),
  },
  {
    path: "/printReport/lisReport",
    name: "lisReport",
    component: () => import("@/views/printReport/lisReport"),
  },
  {
    path: "/printReport/middleEarReport",
    name: "middleEarReport",
    component: () => import("@/views/printReport/middleEarReport"),
  },
  {
    path: "/printReport/monthChildrenReport",
    name: "monthChildrenReport",
    component: () => import("../views/printReport/monthChildrenReport"),
  },
  {
    path: "/printReport/phccloudReport",
    name: "phccloudReport",
    component: () => import("../views/printReport/phccloudReport"),
  },
  {
    path: "/printReport/primaryEnrolmentReport",
    name: "primaryEnrolmentReport",
    component: () => import("../views/printReport/primaryEnrolmentReport"),
  },
  {
    path: "/printReport/middlePrimarySecondaryReport",
    name: "middlePrimarySecondaryReport",
    component: () => import("../views/printReport/middlePrimarySecondaryReport"),
  },
  {
    path: "/printReport/refractiveReport",
    name: "refractiveReport",
    component: () => import("../views/printReport/refractiveReport"),
  },
  {
    path: "/printReport/universityReport",
    name: "universityReport",
    component: () => import("@/views/printReport/universityReport"),
  },
  {
    path: "/printReport/visionReport",
    name: "visionReport",
    component: () => import("../views/printReport/visionReport"),
  },
];
